import { Inputs, validationSchema } from '@/entities/RewardSettings/RewardSettingsFormInputs';

const RewardSettings = {
	Plural: 'RewardSettings',
	Single: 'Reward Settings',
	Inputs: Inputs,
	ValidationSchema: validationSchema,
	SaveCallBack: (id) => {
		//router.push(`/rewardSettings/edit/${id}`)
	},
};

export default RewardSettings;
